<template>
  <v-card>
    <TableToolbar
      @load="load(searchParams)"
      @filterCalendar="filterCalendar"
      :totalItems="totalItems"
      @setSearch="setSearch"
      :title="title"
      :module="module"
    />
    <v-data-table
      :items="items"
      :headers="headers"
      :pagination.sync="pagination"
      :total-items="totalItems"
      class="primary"
      ref="dataTable"
      item-key="_id"
    >
      <template v-slot:items="props">
        <slot name="data" :props="getData(props)"></slot>
      </template>

      <template v-slot:expand="props" v-if="expand">
        <slot name="expansion" :props="props"></slot>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import TableToolbar from "./TableToolbar";

export default {
  name: "Table",

  props: {
    module: String,
    title: String,
    items: Array,
    headers: Array,
    totalItems: Number,
    sortKey: String,
    currentPagination: Object,
    expand: Boolean
  },

  components: {
    TableToolbar
  },

  data() {
    return {
      pagination: {
        rowsPerPage: 10,
        sortBy: this.sortKey || "dateCreated",
        descending: true,
        page: 1
      },
      search: "",
      fromDate: null,
      toDate: null,
      waitForTyping: null
    };
  },

  computed: {
    ...mapGetters({
      allAudits: "audits/getAllAudits",
      user: "app/getUser"
    }),
    searchParams() {
      return {
        module: this.module.toLowerCase(),
        ...this.pagination,
        search: this.search || null,
        from: this.fromDate || null,
        to: this.toDate || null
      };
    }
  },

  watch: {
    search(str) {
      if (str === "") {
        this.search = null;
      }
      clearTimeout(this.waitForTyping);
      this.waitForTyping = setTimeout(async () => {
        await this.load(this.searchParams);
      }, 250);
    },

    pagination: {
      handler() {
        this.load(this.searchParams);
      },
      deep: true
    },
    currentPagination: {
      handler(val) {
        if (val) this.pagination = val;
      },
      deep: true
    }
  },

  methods: {
    filterCalendar(from, to) {
      this.toDate = to;
      this.fromDate = from;
      this.load(this.searchParams);
    },
    load(params) {
      if (this.title == "Otter BOL") params.type = "otter";
      this.$store.dispatch("audits/getAllAudits", params);
    },
    setSearch(val) {
      this.search = val;
    },
    getData(props) {
      props.search = this.searchParams;
      return props;
    }
  }
};
</script>

<style>
.remove-animation {
  animation: none !important;
}
.table-icon-rotate-left {
  animation: table-icon-rotate-left 0.3s;
}

.table-icon-rotate-right {
  animation: table-icon-rotate-right 0.3s;
}
@keyframes table-icon-rotate-left {
  100% {
    transform: rotate(0);
  }
  0% {
    transform: rotate(180deg);
  }
}
@keyframes table-icon-rotate-right {
  100% {
    transform: rotate(0);
  }
  0% {
    transform: rotate(-180deg);
  }
}
</style>
